import React, { Component, ReactNode } from 'react';
import CollectionsPicker from './CollectionsPicker/CollectionsPicker';
import BecomeAClient from '../BecomeAClient/BecomeAClient';
import BecomeAClientMobile from '../BecomeAClient/BecomeAClientMobile';
import {
   CollectionsContainer,
   CollectionsContainerClear,
   CollectionsContainerLeft,
   CollectionsContainerLeftContainer,
   CollectionsContainerRight,
   CollectionsPickerContainer,
   BecomeAClientContainer,
   BecomeAClientMobileContainer
} from './Collection.styled';
import config from './../../config';
import { connect, useSelector } from 'react-redux';

interface ICollection {
   id: string;
   name: string;
   groups: ITemplateGroup[];
   type: string;
   metaCollection?: IMetaTemplate[];
}

export interface ICollectionView extends ICollection {
   selectedTemplateId: string;
   selectedTemplateName: string;
   onClick;
   setCollection?: any;
   onLoad;
   isMobile: boolean;
   isLoaded: boolean;
   isLoggedIn: boolean;
   params: any;
}

interface ITemplate {
   Id: string;
   Name: string;
}

export interface ITemplateGroup {
   Templates: ITemplate[];
   Name: string;
}

export interface IMetaTemplate {
   Id: string;
   DisplayName: string;
   Row: string;
}

function mapStateToProps(state) {
   return {
      isLoggedIn: state.auth.authenticated
   };
}

class Collection extends Component<
   {
      isLoggedIn: boolean;
      children: ReactNode;
   },
   {}
> {
   public render() {
      const { isLoggedIn } = this.props;

      return (
         <CollectionsContainer>
            <CollectionsContainerLeft>
               <CollectionsContainerLeftContainer>
                  <CollectionsPickerContainer>
                     <CollectionsPicker />
                  </CollectionsPickerContainer>
               </CollectionsContainerLeftContainer>
               <BecomeAClientContainer>
                  <BecomeAClient />
               </BecomeAClientContainer>
            </CollectionsContainerLeft>

            <CollectionsContainerRight>
               {this.props.children}
               {!isLoggedIn && config.pod == 'NAX' ? (
                  <BecomeAClientMobileContainer>
                     <BecomeAClientMobile />
                  </BecomeAClientMobileContainer>
               ) : null}
            </CollectionsContainerRight>

            <CollectionsContainerClear />
         </CollectionsContainer>
      );
   }
}

export default connect(mapStateToProps, null)(Collection);
